import {useSelector} from 'react-redux'
import {getDeviceCategory} from 'modules/meta/selectors'
import {useRouter} from 'next/router'
import {pathToRegexp} from 'path-to-regexp'

import {useToggle} from '@vio/core/src/experiments/hooks/useToggle'
import {useIsHydrated} from '@vio/core/src/utils/react/hooks/useIsHydrated'

/**
 *  Routes are ordered from most to least specific. /Hotel/Search must come before
 * /Hotel/:hotelSlug/:locale? so that "Search" is never mistaken for a hotelSlug
 */
const CHAT_ENABLED_ROUTES = [
  pathToRegexp('/Hotel/Search', null, {
    sensitive: true
  }),
  pathToRegexp('/Hotel/:hotelSlug/:locale?'),
  pathToRegexp('/')
]

export const useIsFeatureToggledChatEnabled = () => {
  const {pathname} = useRouter()
  const isHydrated = useIsHydrated()
  const toggle = useToggle()
  const deviceCategory = useSelector(getDeviceCategory)

  if (!isHydrated) {
    return false
  }

  return (
    deviceCategory === 'desktop' &&
    CHAT_ENABLED_ROUTES.some(regexp => regexp.exec(pathname)) &&
    toggle('feature-vio-mcp-ai-chat', false, true)
  )
}
